import { useContext } from "react";
import { ClientConfigContext } from "./ClientConfigProvider.tsx";

export const useClientConfig = () => {
  const context = useContext(ClientConfigContext);
  if (!context) {
    throw Error("ClientConfigProvider is missing");
  }
  return context;
};
